import { processSteps } from '@/mocks/siteData';

export default function ProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            合作流程
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            专业流程，确保交付质量
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            每一环节都有严格的质量把控，确保品牌内容策略的精准落地
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-background-200"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4">
            {processSteps.map((item, idx) => (
              <div key={item.step} className="relative text-center group">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-100 border-2 border-background-200 flex items-center justify-center mx-auto mb-5 group-hover:border-primary-400 group-hover:bg-primary-50 transition-all duration-300 relative z-10">
                  <span className="text-xl md:text-2xl font-bold text-primary-500">{item.step}</span>
                </div>
                <h4 className="text-base md:text-lg font-bold text-foreground-950 mb-2">{item.title}</h4>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}